import { render, staticRenderFns } from "./UploadPlaceholder.vue?vue&type=template&id=3e5f8a79"
import script from "./UploadPlaceholder.vue?vue&type=script&lang=ts"
export * from "./UploadPlaceholder.vue?vue&type=script&lang=ts"
import style0 from "./UploadPlaceholder.vue?vue&type=style&index=0&id=3e5f8a79&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports